<template>
  <div class="tag mb-3 mb-md-0">{{ title }}</div>
</template>

<script>
export default {
  name: "interest-tag",
  props: ["title"],
};
</script>

<style scoped>
.tag {
  background: var(--tag-color);
  font-size: 12px;
  border-radius: 2px;
  padding: 2px 7px;
  font-family: artifaktElementRegular;
  font-weight: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/InterestTag.vue